import React from 'react';

interface LogoProps {
  light?: boolean;
}

const Logo: React.FC<LogoProps> = ({ light = false }) => {
  const logoPath = '/rain_idx_logo.png';

  return (
    <div className="flex items-center">
      <img
        src={logoPath}
        alt="rAIn IDX Logo"
        className="h-8 md:h-10 w-auto"
        style={{
          filter: light ? 'brightness(0) invert(1)' : 'none',
        }}
      />
    </div>
  );
};

export default Logo;